import * as React from "react";
import Header from "./components/Header";
import {Section} from "@athena-portal/components";
import {CoverCheckerPage} from "./pages/CoverCheckerPage";

interface IState {
    showNotification: boolean,
    notificationMessage: string,
    notificationTitle: string
}

export class Layout extends React.Component<{}, IState> {

    public render() {
        return (
            <>
                <div>
                    <Header/>
                    <div className="container-fluid">
                        <div className="container pt-3 pb-3">
                            <CoverCheckerPage/>
                        </div>
                    </div>
                </div>
                <footer className="footer-position">
                    <Section id="footer"/>
                </footer>
            </>
        )
    }

}
